export default __webpack_public_path__ + "static/media/plus.6ad69ddd.svg";